/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(){
  setTimeout(function(){
    
    $('#stickyStrip').show();
  }, 3000);
});

$('#closeStickyStrip').click(function(){
  
  $('#stickyStrip').hide();
});
$("#stickyStrip").on("click",function(){$("#stickyStrip").hide();});

$(".header-search").on("click",function(){
$(".searches_forms").toggle();


});
$(".site-header__navigation").on("click",function(){
  $(".navigation__links").toggle();


});
 